import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import {
  cloudRegionField,
  cloudServiceField,
  cloudVmInstanceTypeField,
  cloudSpendField,
  cloudProviderField,
} from './common/cloudFields';
import { currencyField } from './common/expenditureFields';

export const cloudUsageAndSpendMetadata = {
  displayName: msg({
    message: 'Cloud usage and spend',
    context: 'Activity data schema name for cloud usage and spend',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    cloud_provider: cloudProviderField,
    cloud_provider_region: cloudRegionField,
    cloud_service: cloudServiceField,
    cloud_vm_instance_type: cloudVmInstanceTypeField,
    currency: currencyField,
    currency_quantity: cloudSpendField,
    service_class: {
      displayName: msg({
        message: 'Cloud service class',
        context:
          'An identifier for the cloud service class as compute, networking, storage or other.',
      }),
      externalDescription: msg({
        message:
          'The identifier for the cloud service class as compute, networking, storage or other.',
        context: 'Cloud service class',
      }),
    },
    usage_quantity: {
      displayName: msg({
        message: 'Cloud usage quantity',
        context:
          'The number of instance hours for cloud compute, or bytes of networking or byte-seconds of storage resources.',
      }),
      externalDescription: msg({
        message:
          'The number of instance hours for cloud compute, or bytes of networking or byte-seconds of storage resources.',
        context: 'Cloud usage quantity',
      }),
    },
    usage_unit: {
      displayName: msg({
        message: 'Raw cloud usage unit',
        context: 'The unit associated with the usage quantity field.',
      }),
    },
    // NOTE: quantity does not exist on the BAT but either usage_quantity or
    // currency_quantity is renamed to quantity in the BART-EM matching process
    quantity: {
      displayName: msg({
        message: 'Cloud usage or spend quantity',
        context:
          'The numeric value representing either usage (e.g., instance hours, bytes) or spend (e.g., dollars, credits) for cloud resources.',
      }),
      externalDescription: msg({
        message:
          'The numeric value representing either usage (e.g., instance hours, bytes) or spend (e.g., dollars, credits) for cloud resources.',
        context: 'Cloud usage or spend quantity',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
